export default __webpack_public_path__ + "static/media/phone.dd374cb5.png";